import React, { useState } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { MoreHorizontal, Edit, Trash2 } from 'lucide-react'
import PaginationComponent from '@/components/common/PaginationComponent'
import { formatTableText } from '@/lib/tableUtils'

const ProductsTable = ({ 
  products, 
  onEditProduct, 
  onDeleteProduct,
  currentPage,
  totalPages,
  totalProducts,
  pageSize,
  onPageChange
}) => {
  const getStatusVariant = (status) => {
    switch (status) {
      case 'Active':
        return 'active'
      case 'Inactive':
        return 'delayed'
      default:
        return 'default'
    }
  }

  return (
    <div className="rounded-md border overflow-hidden w-full">
      <div className="max-h-[calc(100vh-250px)] overflow-auto w-full">
        <Table>
          <TableHeader className=" sticky top-0 z-10">
            <TableRow>
              <TableHead className="h-10 px-4 py-1 min-w-[200px]">Product Name</TableHead>
              <TableHead className="h-10 px-4 py-1 min-w-[250px]">Description</TableHead>
              <TableHead className="h-10 px-4 py-1 min-w-[150px]">Unit of Measure</TableHead>
              <TableHead className="h-10 px-4 py-1 min-w-[100px]">Status</TableHead>
              <TableHead className="h-10 px-4 py-1 min-w-[200px]">Created At</TableHead>
              <TableHead className="h-10 px-4 py-1 text-right min-w-[80px]">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {products.map((product) => (
              <TableRow key={product.id} className="hover:bg-transparent border-border">
                <TableCell className="h-10 px-4 py-1">{formatTableText(product.name) || 'N/A'}</TableCell>
                <TableCell className="h-10 px-4 py-1">{formatTableText(product.description) || 'N/A'}</TableCell>
                <TableCell className="h-10 px-4 py-1">{formatTableText(product.unitOfMeasure) || 'N/A'}</TableCell>
                <TableCell className="h-10 px-4 py-1">
                  <Badge
                    variant={getStatusVariant(product.status)}
                    className="inline-block text-center w-[80px]"
                  >
                    {product.status || 'N/A'}
                  </Badge>
                </TableCell>
                <TableCell className="h-10 px-4 py-1">{formatTableText(product.createdAt) || 'N/A'}</TableCell>
                <TableCell className="h-10 px-4 py-1 text-right">
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <Button variant="ghost" className="h-8 w-8 p-0">
                        <MoreHorizontal className="h-4 w-4" />
                      </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end">
                     
                      <DropdownMenuItem onClick={() => onEditProduct(product.id)}>
                        <Edit className="mr-2 h-4 w-4" />
                        Edit Product
                      </DropdownMenuItem>
                      <DropdownMenuItem onClick={() => onDeleteProduct(product.id)} className="text-red-500">
                        <Trash2 className="mr-2 h-4 w-4" />
                        Delete Product
                      </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      
      <PaginationComponent
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalProducts}
        pageSize={pageSize}
        onPageChange={onPageChange}
        className="border-t"
      />
    </div>
  )
}

export default ProductsTable